/**
 * View timeline block.
 * @module components/manage/Blocks/Timeline/View
 */

import React from 'react';
import PropTypes from 'prop-types';
import Body from './Body';
import ViewBlock from './Block/ViewBlock';
import { sortTimelineSubblocks } from './utils';

/**
 * View timeline blocks class.
 * @class View
 * @extends Component
 */
const View = ({ data }) => {
  const sortedSubblocks = sortTimelineSubblocks(data.subblocks);

  return (
    <div className="block timeline">
      <Body data={data} nItems={sortedSubblocks.length}>
        {sortedSubblocks.map((subblock, subindex) => (
          <div className="it-single-slide-wrapper" key={subindex}>
            <ViewBlock data={subblock} />
          </div>
        ))}
      </Body>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
